const STAGING_API_URL = 'https://rcbillable-production.up.railway.app';
const PRODUCTION_API_URL = 'https://rcbillable-production-6281.up.railway.app';

const HOST_API_OVERRIDES = {
  'billablerc.netlify.app': STAGING_API_URL,
  'billablelive.netlify.app': PRODUCTION_API_URL,
};

export const resolveBaseUrl = ({
  baseUrl = process.env.REACT_APP_BASE_URL,
  apiUrl = process.env.REACT_APP_API_URL,
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
} = {}) => {
  const envBaseUrl = String(baseUrl || '').trim() || String(apiUrl || '').trim();
  const host = String(hostname || '').toLowerCase();

  // A configured endpoint must also work on the existing Netlify domains.
  if (envBaseUrl) {
    return envBaseUrl;
  }

  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:3080';
  }

  return HOST_API_OVERRIDES[host] || STAGING_API_URL;
};

const baseUrl = resolveBaseUrl();

export default baseUrl;
